import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import ErrorBoundary from "./components/other/error-boundary";
import "./assets/styles/index.css";
import App from "./app";

// Note: the service worker is registered automatically by vite-plugin-pwa
// (see VitePWA in vite.config.ts), which injects its own registration
// script for the generated /sw.js into index.html. A manual
// navigator.serviceWorker.register("/service-worker.js") call used to live
// here, but that file was never built or copied into the output, so in
// production it resolved to the SPA's index.html fallback and failed to
// install with a MIME-type error.

// Maintenance mode is handled inside <App/> (SiteSettingsProvider +
// RouteEffects). Rendering immediately instead of blocking on a
// site_settings fetch keeps first paint fast.

// Initialize app with error handling
const rootElement = document.getElementById("root");
if (rootElement) {
  try {
    createRoot(rootElement).render(
      <StrictMode>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </StrictMode>
    );
  } catch (error) {
    // console.error("Failed to initialize app:", error);
    rootElement.innerHTML =
      '<div class="loading">Failed to load application</div>';
  }
}
